import { Component, OnInit, HostListener, OnChanges } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { Observable } from 'rxjs/Rx';
import { LocalStorageService } from 'ngx-webstorage';
import { CookieNames, QustionTypes, Time, QustionNavigationStatus, TimeFormatter, ApiEndpoints, BasicRoutes, DynamicClasses , OnlineStatus} from '../../constant';
import { CookieManagerService, HttpClientService, TimeService, BasicTimerService, QnavigatorService, ErrorManagerService, CustomObserverService, GoogleService } from '../../../shared/';
import { TranslateService } from '@ngx-translate/core';
import { PaperPart, Timer, StoredQuestion, Question, Count ,NavigationNumber } from '../../model';
import { Gp1Tp1Component } from '../../paper-layouts';
import { ComponentCanDeactivate } from '../../login/services/route-deactivate';

import swal from 'sweetalert2';

@Component({
  selector: 'app-paper',
  templateUrl: '../views/paper.component.html',
  styleUrls: ['../../../css/paper.component.css', '../../../css/end-exam.component.css', '../../../css/paper-sets.component.css'],
  providers: [GoogleService]

})

export class PaperComponent implements OnInit, ComponentCanDeactivate {

  constructor(
    private translateService: TranslateService,
    private httpClientService: HttpClientService,
    private cookieManagerService: CookieManagerService,
    private timeService: TimeService,
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private qNavigatorService: QnavigatorService,
    private router: Router,
    private errorManagerService: ErrorManagerService,
    private customObserverService: CustomObserverService,
    private googleService: GoogleService
  ) {
    this.listenToQuestions();
  }

  public obs: any;
  public interval: any;
  public realtime: Timer = new Timer();
  public question: Question = new Question();
  public qustionTypes: any = QustionTypes;
  public partId: string;
  public navigateArray: any[];
  public qNumberArray : any ;
  public navNumber : any;
  public submitButtonDisable: boolean = false;
  public questionCount;
  public currentCount;
  public watingTimeNumber: number = 7;
  public PartOne: Count = new Count();
  public PartTwo: Count = new Count();
  public paperId;
  public online: any = OnlineStatus.NOTONLINE;
  public diff;
  public paperPartNumber: any = '0';
  public questingViewingType: string = ApiEndpoints.questingViewingTypeExam;
  // for sub question
  public subQuestionArray: any = [];
  public subQuestionCount: number = 0;
  public subQuestinParent: Question = new Question();
  public allQuestionArray: any = [];
  public allQuestionCount: number = 0;
  public subQuestionVertion: number = 0;
  public allMainQuestionCount: number = 1;

  public openQuestionNo:any = 0;
  isOlredyDone: boolean = false;

  public storedQuestionSubscribe : any ;


  public isFinilize: boolean = false
  @HostListener('click')// check nav tab are clicking or not
  canDeactivate(): Observable<boolean> | boolean {
    if(this.isOlredyDone){
      return this.isOlredyDone;
    }
    return this.isFinilize; // will show a confirm alert before navigating away
  }
  getTranslateService(): TranslateService {
    return this.translateService;
  }
  getPaperPartsInfo(): any {
    let partid = this.question.subpart ? this.question.subpart._id : this.question.partid._id;
    return {
      httpService: this.httpClientService,
      partid: partid,
      version: this.question.version || 0,
      cookieManagerService: this.cookieManagerService,
      timer: this.diff
    }
  }

  getRouter(): any {
    return this.router;
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.submitButtonDisable = false;
    // this.route.params.forEach((params: Params) => { this.partId = params['partid']; }); // store part id from url parameter
    this.partId = this.cookieManagerService.getCookie(CookieNames.paperPartId, false);
    this.paperId = this.cookieManagerService.getCookie(CookieNames.paperId, false); // get paper id from cookeie
    this.paperPartNumber = this.cookieManagerService.getCookie(CookieNames.paperPartNumber, false);
    this.getQuection(1); //get first quection when init
    let items = Object.keys(localStorage);
    items.map(item=>{
      let isStart = item.startsWith('question-');
      isStart ? localStorage.removeItem(item) : false;
    })
    this.customObserverService.setClassName('');
    this.customObserverService.hideNewsAlert({ isOnGoing: true, isShow: false });
    this.online = this.cookieManagerService.getCookie(CookieNames.onlineExam, false);
  }

  // ngAfterViewInit(){
  //   console.log(document.getElementById('news-section'));
  // }

  getQuection(quectionNumber) { /** Get Quection using quection number @param quectionNumber */
    this.timePause();
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getQuestionByPaginate, {
      [ApiEndpoints.partid]: this.partId,
      [ApiEndpoints.questionNumber]: quectionNumber
    }), this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
      this.timePause();
      // check if qustin number is first one
      if(quectionNumber == 1 && !response.question){
        // if there isn't any question
          return;
      }
      if (!response.question) {
        this.endExam(true);
        return;
      }
      // check the sub questions are set or not
      if (response.question.subQuestions.length != 0) {

        this.question = response.question.subQuestions[this.subQuestionCount];
        this.question.time = response.question.time;
        // remove the sub question from parent object
        this.subQuestinParent = response.question;
        this.subQuestionArray = response.question.subQuestions
        this.subQuestinParent.subQuestions = null;
        this.question.parentObj = this.subQuestinParent;
        this.question.questionType = this.subQuestinParent.parentObj.questionType
        this.subQuestionVertion = response.version;
        this.question.questionLabel = this.question.questionNumberLabel;
        // if it's have ony one sub question empty thesub question array 
        if (this.subQuestionArray.length == 1) {
          // if have only one sub question we           
          this.subQuestionArray = [];
          this.subQuestionCount = 0;
        }
      } else {        
        this.question = response.question;
        this.question.questionLabel = this.question.questionNumberLabel;
      }
      // push to question array
      this.allQuestionArray.push(this.question);
      this.question.questionNumber = this.allQuestionArray.length;

      this.question.version = response.version;
      this.questionCount = response.count;
      if (quectionNumber == '1') {
        this.getTime(parseInt(this.question.time));
      } else { // need to get first question as 0 not 1
        // this.allQuestionCount++;
        this.allMainQuestionCount++;
      }
      // if(this.question.questionType === "gr_type_12"){
      //   let 
      // }
      this.qNavigatorService.storeQuestion(this.question);

      if(response.isOlredyDone){
        let that = this;
        swal({
          title: that.translateService.instant('WORNING_HEADER'),
          html:  '<h4>' + that.translateService.instant('MODAL_PAPER_ALREDY_DONE_DESC') + '</h4>',
          showCloseButton: false,
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonClass: 'swal2-confirm',
          confirmButtonText: that.translateService.instant('MODAL_PAPER_ALREDY_DONE_BUTTON'),
          allowOutsideClick: false,
          timer: 12000000
        }).then(() => {
          this.router.navigate(['/home/exams/']);
        });
        this.getTime(parseInt(null));
        this.isOlredyDone = response.isOlredyDone;
      }
    }, error => {
      this.timePause();
      this.errorManagerService.setError(error);
    });
    //document.body.scrollTop = 0;
    window.scrollTo(0, 0);
  }

/**
 * kauhsalya
 * 2017-11-01
 * get the next question from sub question array
 */
  getOnGoingQuection() {
    this.timePause();
    this.subQuestionCount++;
    // get the sub question from sub question array
    this.question = this.subQuestionArray[this.subQuestionCount];

    this.question.parentObj = this.subQuestinParent;
    this.question.questionType = this.subQuestinParent.parentObj.questionType;
    this.question.version = this.subQuestionVertion;
    this.question.questionLabel = this.question.questionNumberLabel;
    // if get last sub question empty the sub question array
    if (this.subQuestionArray.length == this.subQuestionCount + 1) {
      this.subQuestionArray = [];
      this.subQuestionCount = 0;
    }
    // push the question to the all question aray
    this.allQuestionArray.push(this.question);
    // set the question number
    this.question.questionNumber = this.allQuestionArray.length;
    this.question.answers.forEach((answer, i) => {
      if (this.question.selectedAnswerid == answer._id) {
        this.question.selectedAnswerIndex = i;
      }
    });

    // this.allQuestionCount++;

    this.qNavigatorService.storeQuestion(this.question);
    this.timePause();
    if (this.question.correctAnswer.words && (this.question.correctAnswer.words.length == this.question.answerIds.length))
      this.question.isDone = true;

    window.scrollTo(0, 0);
  }

  navClick(question, number) {
    if(typeof this.storedQuestionSubscribe !== 'undefined'){
      this.storedQuestionSubscribe.unsubscribe();
    }
    let qNo : number;
    qNo = number;
    // if((layer == 1 && question.sq.length == 0) || layer == 3 || layer == 2){
    //   qNo = number;
    // }else{
    //   qNo = null;
    // }
    if(qNo!=null){
      this.answerToQuection().then((Response) => {
        this.allQuestionCount = qNo ;
        this.question = this.allQuestionArray[this.allQuestionCount];//new Question(this.allQuestionArray[this.allQuestionCount]);
      });
    }
    this.toggelShowHide(question);
    
    this.openQuestionNo = { 
      'qNo' : question.number,
      'isOpen' : question.isOpen
    }
    window.scrollTo(0, 0);
  }

  toggelShowHide(item) {
    this.qNumberArray.map(i => {
      i == item ? i.isOpen = !i.isOpen : i.isOpen = false;
      return i;
    });
  }
  
  toggleHide(){
    this.qNumberArray = this.qNumberArray.map(i => {
      i.isOpen = false;
      return i;
    });
  }

  nextQuection() { /** Get next new quection if he done it alrady call getOngoing quection. */
    let j = this.allQuestionCount;
    j++;
    if (this.allQuestionArray.length > j) {
      this.answerToQuection().then((Response) => {
        if (Response) {
          this.question = this.allQuestionArray[j];//new Question(this.allQuestionArray[this.allQuestionCount]);
        }
      });
    } else {
      if (this.subQuestionArray.length != 0) { // get the question from sub question array
        this.answerToQuection().then((Response) => {
          this.getOnGoingQuection();
        });
      } else {
        this.answerToQuection().then((Response) => {
          this.getQuection(this.allMainQuestionCount + 1);
        });
      }
    }
    this.allQuestionCount++;

    if(typeof this.storedQuestionSubscribe !== 'undefined'){
      this.storedQuestionSubscribe.unsubscribe();
    }
    this.storedQuestionSubscribe = this.qNavigatorService.storedQuestion.subscribe((res) => {
      this.toggleHide();
    });
    window.scrollTo(0, 0);
  }


  previousQuection() { /** use for back button cureant number - 1 unless disable the button */
    this.answerToQuection().then((Response) => {
      if (Response) {
        this.allQuestionCount--;
        this.question = this.allQuestionArray[this.allQuestionCount];//new Question(this.allQuestionArray[this.allQuestionCount - 1]);
      }
    });
    this.storedQuestionSubscribe = this.qNavigatorService.storedQuestion.subscribe((res) => {
      this.toggleHide();
    });
    window.scrollTo(0, 0);

    // let previousQuectionNumber = parseInt(this.question.questionNumber) - 1;
    // let storedQuection: StoredQuestion = this.getStoreQuectionFromLocalStorage(previousQuectionNumber);
    // this.answerToQuection().then((Response) => {
    //   if (Response && storedQuection) {
    //     this.getOnGoingQuection(storedQuection.id)

    //   }
    // });
  }

  answerToQuection() { /**  Answer to quection */
    let Q = this.question;
    let idArray = Q.answerIds;
    Q.isSkiped = Q.selectedAnswerid ? false : idArray && idArray.length > 0 ? false : true;
    this.customObserverService.setClassName('');
    return new Promise((resolve, reject) => {
      this.timePause();
      this.httpClientService.authPostWithSetId(ApiEndpoints.answerToQuesion, {
        questionid: Q._id,
        answerid: Q.selectedAnswerid,
        partid: this.partId,
        isSkiped: Q.isSkiped,
        category: Q.category,
        subCategory: Q.subCategory,
        answerIds: Q.answerIds,
        parentQuestionObj: Q.parentQuestionObj ? Q.parentQuestionObj._id : null,
        version: Q.version,
        isUnderline: Q.isUnderline,
        isCircle: Q.isCircle,
        userOptionCircle: Q.userOptionCircle,
        userOptionUnderline: Q.userOptionUnderline,
        isOnlineExam: this.online == 'ONLINE' ? true : false
      }, this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
        this.qNavigatorService.storeQuestion(Q);
        this.timePause();
        resolve(true);
      }, error => {
        this.timePause();
        this.errorManagerService.setError(error);
      });
    });
  }

  endExam(isManualyExist) {/** @param isManualyExist */
    this.answerToQuection().then((res) => {
      if (!res) {
        this.errorManagerService.setError(null);
        return;
      }
      let that = this;
      let tatal = this.questionCount - this.currentCount;
      if (isManualyExist) {
        swal({
          title: that.translateService.instant('MODAL_PAPER_END_TITLE'),
          html:  '<h4>' + that.translateService.instant('MODAL_PAPER_END_DESC') + '</h4><br><p class="crt-ans-p">' + that.translateService.instant('END_QUECTIONS') + this.currentCount + ' ' + '</p><p class="wrng-ans-p">' + that.translateService.instant('NOT_DONE') + tatal + '</p></div></div>',
          showCloseButton: false,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonClass: 'swal2-confirm-left',
          confirmButtonText: that.translateService.instant('BTN_CONFIRM'),
          cancelButtonText: that.translateService.instant('BTN_IGNORE'),
          preConfirm: () => {
            return new Promise((resolve, reject) => {
              resolve();
            })
          },
          allowOutsideClick: false,
          timer: 12000000
        }).then(() => {



          that.finalizeExam();
        }, (dismiss) => {
          if (dismiss === 'cancel') {
            that.customObserverService.setClassName('');
            that.isFinilize = false;
            this.allQuestionCount = this.allQuestionArray.length-1;
            return;
          }
        });
      } else {
        let timer = setInterval(() => {
          if (this.watingTimeNumber <= 0) {
            clearInterval(timer);
            that.finalizeExam();
          }
          this.watingTimeNumber--;
        }, 1000)
      }
    });
  }

  finalizeExam() {
    this.realtime.pause = false;
    this.obs.unsubscribe();
    this.timePause();
    
    this.httpClientService.authPostWithSetId(ApiEndpoints.finalizeExam, {
      partid: this.partId,
      paperid: this.cookieManagerService.getCookie(CookieNames.paperId, false),
      version: this.question.version,
    }, this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
      this.customObserverService.setClassName(DynamicClasses.resultBg);
      this.timePause();
      this.isFinilize = true;
      if (response.currentPartObj.partNumber == 1) {
        this.PartOne = response.currentPartObj;
      } else {
        this.PartTwo = response.currentPartObj;
      }
      if (response.nextPartObj.partNumber == 2) {
        this.PartTwo = response.nextPartObj;
      } else {
        this.PartOne = response.nextPartObj;
      }

      let username = this.cookieManagerService.getCookie(CookieNames.username, false) as string;
      this.googleService.emitEvent("EndPaper", "Complete paper part", 'paper', 1);
      window.scrollTo(0, 0);
    }, error => {
      this.timePause();
      this.errorManagerService.setError(error);
    });
  }

  getTime(fullTime: number) { /** Haddle Paper Time @param fullTime */
    this.realtime.future.setHours(this.realtime.future.getHours() + Math.floor(fullTime / 60));
    this.realtime.future.setMinutes(this.realtime.future.getMinutes() + Math.floor(fullTime % 60));
    this.realtime.future.setSeconds(this.realtime.future.getSeconds());

    let observableTimer = new Observable((observer) => {
      this.obs = observer;
      this.interval = setInterval(() => {
        observer.next(true);
      }, 1000);
    });

    observableTimer.subscribe((response: any) => {
      let ftime = TimeFormatter;
      this.diff = this.realtime.future.getTime() - this.realtime.time.getTime();
      if (response) {
        let timeArray = this.timeService.dhms(this.diff / 1000);
        if (this.diff <= 0) {
          this.obs.unsubscribe();
          this.endExam(false);
        }

        if (timeArray[1] <= 4 && timeArray[0] == 0) {
          this.realtime.timerColour = 'text-danger';
        }
        this.realtime.time = new Date();
        this.realtime.timeInText = (timeArray[0] + ftime.hour + timeArray[1] + ftime.minute + Math.round(timeArray[2]) + ftime.second).toString();
        if (Math.round(timeArray[1]) <= 1) {
          this.submitButtonDisable = true;
        } else {
          this.submitButtonDisable = false;
        }
      }
    });
  }

  timePause() {
    if (this.obs == undefined)
      return;
    this.realtime.pause = !this.realtime.pause;
    if (this.realtime.pause && this.obs) {
      this.obs.next(false);
      clearInterval(this.interval);
    } else {
      this.interval = setInterval(() => {
        this.obs.next(true);
      }, 100);
    }
  }

  listenToQuestions() {
    this.qNavigatorService.storedQuestion.subscribe((response) => {
     this.navigateArray = response;
      let navList = [];
      if(this.navigateArray){
        let qnumberArray = this.arrangeItems(this.navigateArray);
        this.qNumberArray = NavigationNumber.fromJSONArray(qnumberArray,this.openQuestionNo);
      }  
    });
    this.qNavigatorService.compleatedQuestion.subscribe((count: any) => {
      this.currentCount = count;
    });
  }

  arrangeItems(navList) {
    let indexNo  : number =0;
    var items = navList.reduce((p, c) => {
      let obj = {
        'q': {},
        'sq': []
      };
      
      if(!c.q){
        obj.q ={ 'label' : c.questionLable , 'index':indexNo++ , 'isNew' : c.isNew , 'isSkiped': c.isSkiped , 'isDone' : c.done, 'isLabel': true};
        return p.concat(obj);
      }
      else if(c.q && !c.q.sq ){
        if(c.q.sq != ""){
        obj.q ={ 'label' : c.q.q ,'index':indexNo , 'isNew' : c.isNew , 'isSkiped': c.isSkiped , 'isDone' : c.done, 'isLabel': true};
        return p.concat(obj);
       }
       else{
          if( (p[p.length-1] || false) && p[p.length-1].q.label == c.q.q){
            p[p.length-1].sq.push({ 'label' : c.q.ssq , 'index':indexNo++});
            return p;
          }else{
            obj.q ={ 'label' : c.q.q ,'index':indexNo , 'isNew' : c.isNew , 'isSkiped': c.isSkiped , 'isDone' : c.done, 'isLabel': false};
            obj.sq.push({ 'label' : c.q.ssq , 'index':indexNo++ });
          }  	
        }	
        return p.concat(obj); 
      }
     else if(c.q.ssq){
        if((p[p.length-1] || false) && p[p.length-1].q.label == c.q.q){
          if(p[p.length-1].sq[p[p.length-1].sq.length-1].label == c.q.sq){   
            p[p.length-1].sq[p[p.length-1].sq.length-1].ssq.push({'label' : c.q.ssq , 'index':indexNo++}) ;   
          }else{  	
            p[p.length-1].sq.push({ 'label' : c.q.sq});
            p[p.length-1].sq[p[p.length-1].sq.length-1]['ssq'] = [{'label' : c.q.ssq , 'index':indexNo++}] ;  
          }
          return p; 
        }else if(p){
            obj.q = { 'label' : c.q.q , 'index':indexNo ,'isNew' : c.isNew , 'isSkiped': c.isSkiped , 'isDone' : c.done , 'isLabel': true};
            obj.sq.push({ 'label' : c.q.sq});
            obj.sq[obj.sq.length -1]['ssq'] = [{'label' : c.q.ssq , 'index':indexNo++}] ;
            return p.concat(obj); 
        }
      }
    
    
    },[]);
    return items;
  }

  getStoreQuectionFromLocalStorage(number): StoredQuestion {
    return JSON.parse(localStorage.getItem("question-" + number));
  }

  routeToPaperPart(status) {
    this.customObserverService.setClassName('');
    if (status) {
      this.router.navigate(['/home/exams/papers/' + this.paperId + '/parts']);
    } else {
      (this.online)? this.router.navigate(['/home/exams/online'])
      : this.router.navigate(['/home/exams/']);
    }
  }

  goToResults() {
    let paperSetId = this.cookieManagerService.getCookie(CookieNames.paperSetKey, false);
    this.router.navigate(['home/statistics/papers/' + paperSetId]);
  }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/paper-sets/components/paper.component.ts